<template>
    <v-layout row wrap>
        <!-- <v-flex xs12>
          <h2 class="headline">Overview of Project</h2>
        </v-flex> -->
        <v-flex
          v-for="item in dynamicBlock"
          v-bind:key="item.key"
          d-flex
          xs6
          sm4
          md3
          lg3
        >
            <v-card color="indigo" dark class="pa-1">
                <v-card-title class="title">
                {{ item.title }}
                </v-card-title>
                <v-card-text class="display-2 text-xs-center">
                <v-icon x-large left class="bg-icon">
                    {{ item.icon || "event" }}
                </v-icon>
                {{ item.value }}
                </v-card-text>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
import { mapGetters } from "vuex";  

export default ({
    data: () => ({
      dynamicBlock: [],
    }),

    created() {
      this.fetchReport();
    },

    computed: {
      ...mapGetters(["isLoggedIn","indexData"])
    },

    methods: {
      async fetchReport() {
        await this.$store.dispatch("setIndexData", ["dynamic-block"]);
        this.updateCharts();
      },

      async updateCharts() {   
        this.dynamicBlock = this.indexData.dynamic_block;
      }
    }
});
</script>
